import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiShopService } from '../../../../services/shop/api/api-shop.service';
import { AlertsService } from '../../../../services/alerts.service';
import { ShopItem } from '../../../../models/shop/shop-item.model';
import { ShopItemReward } from '../../../../models/shop/shop-item-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-shop-item-edit-modal',
  templateUrl: './shop-item-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class ShopItemEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  itemId: number = 0;
  name: string = '';
  iapId: string = '';
  price: number = 0;
  isPack: boolean = false;
  rewards: ShopItemReward[] = [];
  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiShopService: ApiShopService, private alertsService: AlertsService) {}

  show(item: ShopItem, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.itemId = item.itemId;
    this.name = item.name;
    this.iapId = item.iapId;
    this.price = item.price;
    this.isPack = item.isPack;
    this.rewards = item.rewards.map(r => {
      const reward = new ShopItemReward();
      reward.currencyType = r.currencyType;
      reward.currencyQuantity = r.currencyQuantity;
      reward.currencyTicketCost = r.currencyTicketCost;
      reward.currencyIncreasePercent = r.currencyIncreasePercent;
      return reward;
    });
    this.isLoading = false;
    this.modal.show();
  }

  addReward(): void {
    const r = new ShopItemReward();
    this.rewards.push(r);
  }

  removeReward(index: number): void {
    this.rewards.splice(index, 1);
  }

  save(): void {
    this.isLoading = true;
    this.apiShopService.editItem(this.itemId, this.name, this.iapId, this.price, this.isPack, this.rewards).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Item updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating item : ' + error);
      }
    );
  }
}
